module.exports = __webpack_public_path__ + "static/media/iphone.c5e4da36.png";